export default __webpack_public_path__ + "3f045d6f11120d5fc6764beaf2f58a74.png";